import { render, staticRenderFns } from "./JBProposalStockValues.vue?vue&type=template&id=0d38263c"
import script from "./JBProposalStockValues.vue?vue&type=script&lang=js"
export * from "./JBProposalStockValues.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports